import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { useCreateResellerMutation } from "../../store/services/customerApi";

const MakeReseller = ({ isOpen, onClose, customerData }) => {
  const [domainName, setDomainName] = useState("");
  const [telemarketerID, setTelemarketerID] = useState("1702165536843139597");
  const [selectedOption, setSelectedOption] = useState("Delivery");
  const [error, setError] = useState("");

  const [createReseller, { isLoading }] = useCreateResellerMutation();

  useEffect(() => {
    if (isOpen) {
      setDomainName("");
      setTelemarketerID("1702165536843139597");
      setSelectedOption("Delivery");
      setError("");
    }
  }, [isOpen]);

  const validateInputs = () => {
    if (!domainName || !telemarketerID || !selectedOption) {
      setError("All fields are required.");
      toast.error("All fields are required.");
      return false;
    }

    if (!domainName.match(/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
      setError("Invalid domain name. Example: example.com");
      toast.error("Invalid domain name. Example: example.com");
      return false;
    }

    if (!telemarketerID.match(/^[a-zA-Z0-9]+$/)) {
      setError("Telemarketer ID must be alphanumeric.");
      toast.error("Telemarketer ID must be alphanumeric.");
      return false;
    }

    setError("");
    return true;
  };

  const handleSubmit = async () => {
    if (!validateInputs()) return;

    const payload = {
      reseller_name: customerData?.name || "Default Reseller",
      reseller_domain: domainName,
      TM_ID: telemarketerID,
      TM_ID_type: selectedOption,
      customer_id: customerData?.customer_id,
      is_active: true,
    };

    try {
      await createReseller(payload).unwrap();
      toast.success("Reseller profile created successfully!");
      onClose();
    } catch (err) {
      const errorMessage = err.data?.message || "An error occurred while creating the reseller profile.";
      setError(errorMessage);
      toast.error(errorMessage);
    }
  };

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Make Reseller</DialogTitle>
      <DialogContent>
        <Typography variant="body2" align="center" color="textSecondary" gutterBottom>
          Please add the Domain Name and Telemarketer ID for this customer.
        </Typography>
        <Typography variant="body2" align="center" color="error" gutterBottom>
          NOTE: Ensure the correct information is provided to avoid issues. Incorrect entries may result in errors.
        </Typography>

        <TextField
          fullWidth
          label="Domain Name"
          value={domainName}
          onChange={(e) => setDomainName(e.target.value)}
          variant="outlined"
          margin="normal"
          error={!!error && error.includes("domain")}
          helperText="Enter a valid domain (e.g. example.com)"
          sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
        />
        <TextField
          fullWidth
          label="Telemarketer ID"
          value={telemarketerID}
          onChange={(e) => setTelemarketerID(e.target.value)}
          variant="outlined"
          margin="normal"
          error={!!error && error.includes("Telemarketer ID")}
          helperText="Telemarketer ID must be alphanumeric."
          sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
        />

        <Typography variant="body2" color="error" gutterBottom>
          TM ID Type:
        </Typography>
        <RadioGroup
          row
          value={selectedOption}
          onChange={(e) => setSelectedOption(e.target.value)}
          className="mb-4"
        >
          <FormControlLabel
            value="Aggregator"
            control={<Radio />}
            label="Aggregator"
          />
          <FormControlLabel
            value="Delivery"
            control={<Radio />}
            label="Delivery"
          />
        </RadioGroup>

        {error && (
          <Typography color="error" align="center" variant="body2">
            {error}
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? "Submitting..." : "Submit"}
        </Button>
        <Button color="primary" onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

  export default MakeReseller;
